import { hydrateRoot } from 'react-dom/client'
import { getReactPage } from '@/Shared/AutoGenerated/ReactPages'

const container = document.getElementById('app')

if (!container) {
    throw new Error('React application container is missing.')
}

const pageName = container.dataset.page
const serializedProps = container.dataset.props ?? '{}'

if (typeof pageName !== 'string') {
    throw new Error('React page name is missing.')
}

const PageComponent = getReactPage(pageName)
const props = JSON.parse(serializedProps) as Record<string, unknown>

hydrateRoot(container, <PageComponent {...props} />)
